import { useTranslation } from "react-i18next";
import GenericFallback from "../GenericFallback";

const ConfigurationsContextFallback = () => {
  const { t } = useTranslation("common", { keyPrefix: "messages" });

  return <GenericFallback message={t("configurationsError")} />;
};

export default ConfigurationsContextFallback;
